import AbstractProvidedClass from "../shared/AbstractProvidedClass";

const WIDTH = 840;
const HEIGHT = 600;
const INTERVAL = 60000;

export default class OverviewCapture extends AbstractProvidedClass {
    _scheduled = false;

    schedule() {
        if (this.dataHandler.isNewPlan()) return;
        if (this._scheduled) return;
        this._scheduled = true;
        setTimeout(() => {
            this._scheduled = false;
            this.capture();
        }, INTERVAL);
    }

    capture() {
        if (this.elements.collection.length === 0) return;

        // Save current state
        const savedScale = this.view.scale;
        const savedPosX = this.view.posX;
        const savedPosY = this.view.posY;
        const savedShowLabels = this.settings.showLabels;
        const hoveredElements = this.elements.collection.filter(el => el.isHovered);
        const selectedElements = this.elements.collection.filter(el => el.selected);
        hoveredElements.forEach(el => el.isHovered = false);
        selectedElements.forEach(el => el.selected = false);

        // Set overview state
        const [scale, posX, posY] = this.view.calculateOverview(WIDTH, HEIGHT);
        this.view.scale = scale;
        this.view.posX = posX;
        this.view.posY = posY;
        this.settings.showLabels = false;

        // Create buffer and render
        const buffer = this.p.createGraphics(WIDTH, HEIGHT);
        buffer.background(this.backgroundColor);

        if (this.settings.showImage && this.image && this.image._loaded) {
            buffer.push();
            buffer.translate(posX, posY);
            this.image.display(buffer);
            buffer.pop();
        }

        buffer.push();
        buffer.translate(posX, posY);
        this.elements.display(buffer);
        buffer.pop();

        // Restore state
        this.view.scale = savedScale;
        this.view.posX = savedPosX;
        this.view.posY = savedPosY;
        this.settings.showLabels = savedShowLabels;
        hoveredElements.forEach(el => el.isHovered = true);
        selectedElements.forEach(el => el.selected = true);

        // Extract and upload
        buffer.elt.toBlob((blob) => {
            this.dataHandler.uploadOverview(blob);
            buffer.remove();
        });
    }
}
